import "core-js/modules/es.object.assign";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

import { http } from '../common';
/**
 * 4.2.1 通过微信code获取unionId
 * https://km.sankuai.com/page/195824318#id-4.2.1%E9%80%9A%E8%BF%87%E5%BE%AE%E4%BF%A1code%E8%8E%B7%E5%8F%96unionIdgetUnionIdByWXCode%EF%BC%88/api/invoice/auth/getUnionIdByWXCode%EF%BC%89post
 */

export function getUnionIdByWXCode(data, config) {
  return http(__assign({
    url: 'auth/getUnionIdByWXCode',
    data: data,
    auth: true
  }, config));
}
/**
 * 分页查询用户最近使用过的抬头列表
 * https://km.sankuai.com/page/195824318#id-4.1.8分页查询用户最近使用过的抬头列表queryUserTitlePage（/api/invoice/title/queryUserTitlePage）post
 */

export function queryUserTitlePage(data, config) {
  return http(__assign({
    url: 'title/queryUserTitlePage',
    data: data,
    auth: true
  }, config));
}
/**
 * 获取业务线配置信息
 * https://km.sankuai.com/page/195824318#id-4.4.8获取业务线配置信息queryBizTypeConfig（/api/invoice/process/queryBizTypeConfig）post
 */

export function queryBizTypeConfig(data, config) {
  return http(__assign({
    url: 'process/queryBizTypeConfig',
    data: data,
    auth: true
  }, config));
}
/**
 * 获取纸票前台码配置信息
 * https://km.sankuai.com/page/195824318#id-4.4.2%E8%8E%B7%E5%8F%96%E7%BA%B8%E7%A5%A8%E5%89%8D%E5%8F%B0%E7%A0%81%E9%85%8D%E7%BD%AE%E4%BF%A1%E6%81%AFqueryPaperConfig%EF%BC%88/api/invoice/process/queryPaperConfig%EF%BC%89post
 */

export function queryPaperConfig(data, config) {
  return http(__assign({
    url: 'process/queryPaperConfig',
    data: data,
    auth: true
  }, config));
}
/**
 * 提交纸票前台码申请
 * https://km.sankuai.com/page/195824318#id-4.4.1%E6%8F%90%E4%BA%A4%E7%BA%B8%E7%A5%A8%E5%89%8D%E5%8F%B0%E7%A0%81%E7%94%B3%E8%AF%B7applyInvoicePaper%EF%BC%88/api/invoice/process/applyInvoicePaper%EF%BC%89post
 */

export function applyInvoicePaper(data, config) {
  return http(__assign({
    url: 'process/applyInvoicePaper',
    data: data,
    auth: true
  }, config));
}
/**
 * 获取发票详情
 * https://km.sankuai.com/page/195824318#id-4.4.7%E8%8E%B7%E5%8F%96%E5%8F%91%E7%A5%A8%E8%AF%A6%E6%83%85queryInvoiceDetailByInvoiceId%EF%BC%88/api/invoice/process/queryInvoiceDetailByInvoiceId%EF%BC%89post
 */

export function queryInvoiceDetailByInvoiceId(data, config) {
  return http(__assign({
    url: 'process/queryInvoiceDetailByInvoiceId',
    data: data,
    auth: true
  }, config));
}
/**
 * 获取电票前台码配置信息
 * https://km.sankuai.com/page/195824318#id-4.4.4%E8%8E%B7%E5%8F%96%E7%94%B5%E7%A5%A8%E5%89%8D%E5%8F%B0%E7%A0%81%E9%85%8D%E7%BD%AE%E4%BF%A1%E6%81%AFqueryElecConfig%EF%BC%88/api/invoice/process/queryElecConfig%EF%BC%89post
 */

export function queryElecConfig(data, config) {
  return http(__assign({
    url: 'process/queryElecConfig',
    data: data,
    auth: true
  }, config));
}
/**
 * 提交电票前台码开票
 * https://km.sankuai.com/page/195824318#id-4.4.3%E6%8F%90%E4%BA%A4%E7%94%B5%E7%A5%A8%E5%89%8D%E5%8F%B0%E7%A0%81%E5%BC%80%E7%A5%A8applyInvoiceElec%EF%BC%88/api/invoice/process/applyInvoiceElec%EF%BC%89post
 */

export function applyInvoiceElec(data, config) {
  return http(__assign({
    url: 'process/applyInvoiceElec',
    data: data,
    auth: true
  }, config));
}
/**
 * 获取小票码配置信息
 * https://km.sankuai.com/page/195824318#id-4.4.3%E6%8F%90%E4%BA%A4%E7%94%B5%E7%A5%A8%E5%89%8D%E5%8F%B0%E7%A0%81%E5%BC%80%E7%A5%A8applyInvoiceElec%EF%BC%88/api/invoice/process/applyInvoiceElec%EF%BC%89post
 */

export function queryReceiptQrCode(data, config) {
  return http(__assign({
    url: 'process/queryReceiptQrCode',
    data: data,
    auth: true
  }, config));
}
/**
 * 获取发票列表
 * https://km.sankuai.com/page/1086105253#id-3.3.4%E6%8A%AC%E5%A4%B4%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3%E6%9A%82%E6%97%A0%E6%94%B9%E5%8A%A8
 */

export function queryCanApplyElecInvoice(data, fetchCount, config) {
  return http(__assign({
    url: 'order/queryCanApplyOrderList',
    data: data,
    auth: true
  }, config));
}
/**
 * 开票金额查询
 */

export function queryOrderInfoList(data, config) {
  return http(__assign({
    url: 'order/queryOrderInfoList',
    data: data,
    auth: true
  }, config));
}
/**
 * 订单校验接口
 * https://km.sankuai.com/page/195824318#id-4.4.3%E6%8F%90%E4%BA%A4%E7%94%B5%E7%A5%A8%E5%89%8D%E5%8F%B0%E7%A0%81%E5%BC%80%E7%A5%A8applyInvoiceElec%EF%BC%88/api/invoice/process/applyInvoiceElec%EF%BC%89post
 */

export function orderValidation(data, config) {
  return http(__assign({
    url: 'order/orderValidation',
    data: data,
    auth: true
  }, config)); // let testData = {
  //   "code": 200,
  //   "data": {
  //     "verifyState": false, // 验证状态码
  //     "canInvoiceAmount": '1000',// 可开金额
  //     "orderList": [
  //       {
  //         "bizId": "2", // 验证状态码
  //         "goodName": '1000',
  //         "saleName": '星巴克',
  //         "feeAmount": 111,
  //         "goodsDetail": [
  //           {
  //             "goodsName": '食品',
  //           },
  //           {
  //             "goodsName": '玩具',
  //           },
  //         ]
  //       },
  //       {
  //         "bizId": "2", // 验证状态码
  //         "goodName": '1000',
  //         "saleName": '星巴克',
  //         "feeAmount": 2222,
  //         "goodsDetail": [
  //           {
  //             "goodsName": '食品',
  //           },
  //           {
  //             "goodsName": '玩具',
  //           },
  //         ]
  //       },
  //       {
  //         "bizId": "2", // 验证状态码
  //         "goodName": '1000',
  //         "saleName": '星巴克',
  //         "feeAmount": 3333,
  //         "goodsDetail": [
  //           {
  //             "goodsName": '食品',
  //           },
  //           {
  //             "goodsName": '玩具',
  //           },
  //         ]
  //       }
  //     ], // 发票详情列表
  //   }
  // }
  // return new Promise((resolve)=>{
  //   resolve(testData)
  // })
} // /**
//  * 星巴克订单发票状态查询接口
//     https://km.sankuai.com/page/1086105253
//  */
// export function queryInvoiceInfo (data:any, config?:ApiConfig) {
//   // return http({
//   //   url: 'order/queryInvoiceInfo',
//   //   data,
//   //   auth: true,
//   //   ...config,
//   // });
//   let testData =  {
//     "address": "voluptate s",
//     "addressPhone": "ve",
//     "bankAccount": "ipsum non enim Duis",
//     "bankName": "esse voluptate",
//     "bankNameAccount": "in",
//     "bizCustomerId": "dolore voluptate",
//     "bizId": "voluptate in ex",
//     "bizType": -9376664.850551158,
//     "bizTypeName": "nisi enim",
//     "callbackBizTime": 3307486.780891016,
//     "checker": "ipsum in voluptate dolor exercitation",
//     "code": "quis",
//     "ctime": 54697837.56351867,
//     "deadlineTime": -48817507.76756406,
//     "electronicInvoiceCode": "in occaecat",
//     "electronicInvoiceMsg": "dolore",
//     "excludeTaxFee": -85961781.84609546,
//     "finishTime": 36064657.464099795,
//     "flushRedFlag": 89490753.05098438,
//     "flushRedTime": 71503802.48868334,
//     "goodsCodeVersion": "esse aute do",
//     "goodsDetail": [
//       {
//         "count": -56168598.21843212,
//         "createTime": 19407787.87000808,
//         "deduction": -5320852.852811068,
//         "excludeTaxFee": 53158149.003070086,
//         "excludeTaxUnitPrice": 10813637.975234821,
//         "fee": 396284.1329396814,
//         "goodsCode": "aute id Duis",
//         "goodsName": "ve",
//         "goodsNameAbbr": "ut",
//         "invoiceLineType": 3520891.365990892,
//         "modifiedTime": 10368395.110798806,
//         "preferentialPolicyFlag": -88024816.68297242,
//         "tax": 57928129.925964594,
//         "taxRate": 2349983.252521023,
//         "unitPrice": 33431977.19121714,
//         "unitPriceUseTaxFlag": -26795132.35465683
//       }
//     ],
//     "invoiceApplySourceType": -82130181.03327733,
//     "invoiceChannel": 82277501.02904472,
//     "invoiceFileType": 69135723.0189881,
//     "invoiceId": "irure",
//     "invoiceTime": -45498260.655303605,
//     "invoiceType": -79099466.23973733,
//     "isSyncInvoiceStatus": -24071004.439712822,
//     "isTest": 97054623.99697492,
//     "machineCode": "Excepteur consectetur",
//     "makeOutInvoiceType": -56602494.76232613,
//     "makeOutStatus": 59072052.634682834,
//     "mtUserId": 9422934.814616874,
//     "name": "consequat eiusmod do ea",
//     "nonMtUserId": -32679017.63301979,
//     "notifyTime": -74660127.0441042,
//     "orderCount": -86857556.20163618,
//     "originInvoiceCode": "consequat i",
//     "originInvoiceNumber": "sunt consectetur voluptate",
//     "payee": "ad",
//     "phone": "labore cupidatat dolor nulla deserunt",
//     "poiId": 54865665.7236712,
//     "printer": "velit in",
//     "purchaseFlag": 47802083.84481382,
//     "pushTime": -80944355.96785057,
//     "receiverEmail": "mollit cillum",
//     "receiverPhone": "ut",
//     "reportTime": -38599881.96904505,
//     "saleAddress": "amet",
//     "saleAddressPhone": "dolore ut",
//     "saleBankAccount": "ipsum dol",
//     "saleBankName": "enim quis ipsum culpa sint",
//     "saleBankNameAccount": "officia do",
//     "saleCode": "ipsum reprehenderit commodo adipisic",
//     "saleName": "cupidatat quis minim ad",
//     "salePhone": "sit occaecat eu",
//     "signTime": -35924859.70532446,
//     "status": 38422225.519016,
//     "storageTime": 93507310.03188622,
//     "subBizType": 38804990.786921024,
//     "taxFee": -77629017.37990013,
//     "taxFlag": -44756738.36607532,
//     "totalFee": -88890699.01133987,
//     "utime": -52387160.24817625
//   }
//   return new Promise((resolve)=>{
//     resolve(testData)
//   })
// }

/**
 * 提交电票小票码开票申请
 * https://km.sankuai.com/page/195824318#id-4.4.5%E6%8F%90%E4%BA%A4%E7%94%B5%E7%A5%A8%E5%B0%8F%E7%A5%A8%E7%A0%81%E5%BC%80%E7%A5%A8%E7%94%B3%E8%AF%B7applyReceiptCodeInvoice%EF%BC%88/api/invoice/process/applyReceiptCodeInvoice%EF%BC%89post
 */

export function applyReceiptCodeInvoice(data, config) {
  return http(__assign({
    url: 'process/applyReceiptCodeInvoice',
    data: data,
    auth: true
  }, config));
}
/**
 * 批次订单开票申请
 * https://km.sankuai.com/page/1202761195#id-%E8%AF%B7%E6%B1%82%E5%BC%80%E7%A5%A8
 */

export function applyBatchInvoice(data, config) {
  return http(__assign({
    url: 'order/submitBatchInvoice',
    data: data,
    auth: true
  }, config));
}
/**
 * 星巴克开票申请
 * https://km.sankuai.com/page/1086105253
 */

export function applyElecInvoice(data, config) {
  return http(__assign({
    url: 'order/applyBizElecInvoice',
    data: data,
    auth: true
  }, config));
}
/**
 * 通过当前环境获取美团用户信息
 * https://km.sankuai.com/page/195824318#id-4.2.2%E9%80%9A%E8%BF%87%E5%BD%93%E5%89%8D%E7%8E%AF%E5%A2%83%E8%8E%B7%E5%8F%96%E7%BE%8E%E5%9B%A2%E7%94%A8%E6%88%B7%E4%BF%A1%E6%81%AFqueryUserInfo%EF%BC%88/api/invoice/auth/queryUserInfo%EF%BC%89post
 */

export function queryUserInfo(data, config) {
  return http(__assign({
    url: 'auth/queryUserInfo',
    data: data,
    auth: true
  }, config));
}
/**
 * 跳转小票码开票接口
 * https://yapi.sankuai.com/project/15253/interface/api/601000 get
 */

export function jumpReceiptInvoicePage(data, config) {
  return http(__assign({
    url: 'order/jumpReceiptInvoicePage',
    data: data,
    auth: true
  }, config));
}
/**
 * @description: 通过业务类型和申请业务ID查询上一次发票申请信息，可用于判断是否已申请发票
 * @param {any} data
 * @param {ApiConfig} config
 * @return {*}
 */

export function getLastApplyInfo(data, config) {
  return http(__assign({
    url: 'center/getLastApplyInfo',
    data: data,
    auth: true,
    method: 'post'
  }, config));
}
/**
 * 可开列表金额校验
 * https://yapi.sankuai.com/project/15253/interface/api/772058 post
 */

export function checkInvoiceAmount(data, config) {
  return http(__assign({
    url: 'order/checkInvoiceAmount',
    data: data,
    auth: true
  }, config));
}
/**
 * @description: 获取商家开票能力信息
 * @param {object} data
 * @param {ApiConfig} config
 * @return {*}
 */

export function queryMerchantInvoiceAbility(data, config) {
  return http(__assign({
    url: 'title/queryTitlePageTips',
    data: data,
    auth: true
  }, config));
}
/**
 * @description: 查询用户历史接收信息
 * @param {object} data
 * @param {ApiConfig} config
 * @return {*}
 */

export function queryUserLatestReceiveInfo(data, config) {
  return http(__assign({
    url: 'userPersonal/queryUserLatestReceiveInfo',
    data: data,
    auth: true
  }, config));
}